function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import AssetFieldsConfig from "components/core/asset/fields-config";
import FullWithBulletsParagraphConfig from "segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-config";
import { newBrandColors } from "constants/color-picker-constants";
import TitleConfig from "segments/desktop/core-components/title/fields-config";
const _FullWithBulletsParagraphConfig_fields = FullWithBulletsParagraphConfig.fields, { topic, buttonConfig, body, theme, mobileTextAlign, bodyColor, titleColor, bulletsConfig } = _FullWithBulletsParagraphConfig_fields, restOfFullWithBulletsParagraphConfigFields = _object_without_properties(_FullWithBulletsParagraphConfig_fields, [
    "topic",
    "buttonConfig",
    "body",
    "theme",
    "mobileTextAlign",
    "bodyColor",
    "titleColor",
    "bulletsConfig"
]);
export default {
    type: FIELD_TYPES.NESTED,
    label: "Products By Use Cases",
    fields: {
        horizontalPadding: {
            type: FIELD_TYPES.TEXT,
            label: "Products horizontal padding"
        },
        tagsTitle: {
            type: FIELD_TYPES.TEXT,
            label: "Tags title",
            textArea: true,
            translatable: true
        },
        sideBarTitle: {
            type: FIELD_TYPES.TEXT,
            label: "Use cases side bar title",
            textArea: true,
            translatable: true
        },
        useCases: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Use cases",
            nestedConfig: {
                type: FIELD_TYPES.NESTED,
                fields: {
                    tag: {
                        type: FIELD_TYPES.NESTED,
                        fields: {
                            text: {
                                type: FIELD_TYPES.TEXT,
                                label: "Tag text",
                                translatable: true
                            },
                            color: {
                                type: FIELD_TYPES.COLOR_PICKER,
                                label: "Tag Color",
                                possibleColors: [
                                    ...newBrandColors,
                                    "orange"
                                ]
                            }
                        }
                    },
                    clusterId: {
                        type: FIELD_TYPES.CLUSTERS,
                        label: "Cluster Id"
                    },
                    product: {
                        label: "Product",
                        type: FIELD_TYPES.NESTED,
                        fields: _object_spread_props(_object_spread({}, restOfFullWithBulletsParagraphConfigFields), {
                            productType: {
                                type: FIELD_TYPES.PRODUCTS,
                                label: "Product type"
                            },
                            bulletsConfig: {
                                type: FIELD_TYPES.NESTED,
                                label: "Product use cases",
                                fields: {
                                    bullets: bulletsConfig.fields.bullets
                                }
                            },
                            asset: {
                                type: FIELD_TYPES.NESTED,
                                label: "Asset",
                                fields: AssetFieldsConfig
                            }
                        })
                    }
                }
            }
        }
    }
};
